<template>
  <div class="bluefire-wap-wrap">
    <wap-header header-text="回访统计" :header-visible="true" :back-visible="true" :user-list-lock.sync="userListLock" controller="h5" action="visit" :title-type-lock="false"/><!--参数都可以不传-->
    <scroll-refresh>
      <div class="tools-wrap wap-channel-wrap">
        <div class="rows-div">
          <div class="top-info-area">
            <span class="s_title">
              回访统计
            </span>
            <span class="s_right">
              <font v-if="chartsSort.options.length">排序</font>
              <el-select
                v-model="chartsSort.value"
                placeholder="请选择排序方式"
                size="mini"
                v-if="chartsSort.options.length"
                @change="setChartsSort">
                <el-option
                  v-for="item in chartsSort.options"
                  :key="item"
                  :label="item"
                  :value="item"/>
              </el-select>
              <el-button :class="screenBtnStyle ? 'active' : ''" type="primary" @click="showFilter">筛选</el-button>
            </span>
          </div>
          <div class="chart-div">
            <bi-bar
              :data="chartsData.data"
              :options="chartsData.options"
              :refresh="chartsData.refresh"
              @reload="initCharts"/>
          </div>
        </div>
        <div class="channel-list-wrap2">
          <data-list :url="url"
                     :search-data="searchData"
                     :refresh.sync="refresh"
                     :refresh-lock="true">
            <template slot-scope="{ item, index, header, refresh }">
              <div class="channel-list-special">
                <div>{{ item.truename }}</div>
                <div v-if="item.lianxi"><span>联系型</span><span>{{ item.lianxi }}</span></div>
                <div v-if="item.genjin"><span>跟进型</span><span>{{ item.genjin }}</span></div>
                <div v-if="item.yunying"><span>运营型</span><span>{{ item.yunying }}</span></div>
              </div>
            </template>
          </data-list>
        </div>
      </div>
    </scroll-refresh>
    <popup-filter :show-lock.sync="showFilterLock" :search-data.sync="searchData" :search-ds="searchDsUrl">
      <el-button slot="close-button" @click="closePopupFilter" class="btn-close-popup-fullpage"><font>×</font></el-button>
    </popup-filter>
  </div>
</template>
<script>
import header from '@/pages/h5/compoments/header';
import scrollRefresh from '@/pages/h5/compoments/scrollRefresh';
import BiBar from '@/components/charts/biBar';
import popupFilter from './compoments/popupFilter';
import common from '@/pages/bi/common';
import dataList from '@/pages/h5/compoments/dataList';

export default {
  data() {
    return {
      userListLock: true,
      chartsData: {
        refresh: 1
      },
      chartsSort: {
        options: [],
        value: '联系型'
      },
      refresh: false,
      showFilterLock: false,
      searchData: {
        teacher_id: [],
        timeline: []
      },
      url: '/index/b_i_visit/getVisitPage',
      searchDsUrl: '/index/b_i_visit/index',
      screenBtnStyle: false,
    };
  },
  components: {
    'wap-header': header,
    scrollRefresh,
    BiBar,
    popupFilter,
    dataList
  },
  mixins: [common],
  methods: {
    init() {
      this.refresh = true;
      this.initCharts();
    },
    initCharts() {
      this.fetchData({
        url: '/index/b_i_visit/getVisitChart',
        field: 'chartsData',
        param: this.searchData,
        option: {
          margin: {
            top: 50, right: 30, bottom: 20, left: 0
          },
          colors: ['#7D94FF', '#FF8EDA', '#FFCD6C'],
          barWidth: 30,
          defaultBarWidth: 60,
          labelWidthPercent: 100 / 3,
          domainType: 'string',
          groupType: false,
          helpLine: true,
          fontSize: 14,
        },
        sort: 'chartsSort'
      });
    },
    setChartsSort() {
      this.chartsData = this.sortData(this.chartsData, this.chartsSort.value);
    },
    closePopupFilter() {
      this.showFilterLock = false;
    },
    showFilter() {
      this.showFilterLock = true;
    },
  },
  watch: {
    showFilterLock(v) {
      if (!v) {
        this.$nextTick(this.init);
        this.refresh = true;
      }
      if (this.searchData.teacher_id.length > 0
        || this.searchData.timeline.length > 0) {
        this.screenBtnStyle = true;
      } else {
        this.screenBtnStyle = false;
      }
    }
  },
  mounted() {
    // let timestamp = new Date();
    // let tyear = timestamp.getFullYear();
    // let tmonth = (timestamp.getMonth() + 1) < 10 ? `0${timestamp.getMonth() + 1}` : timestamp.getMonth() + 1;
    // let tday = timestamp.getDate() < 10 ? `0${timestamp.getDate()}` : timestamp.getDate();
    // this.searchData.timeline.push(`${tyear}-${tmonth}-01`);
    // this.searchData.timeline.push(`${tyear}-${tmonth}-${tday}`);
    this.init();
  }
};
</script>
